import Modal from './Modal';

interface CertificateInformationModalProps {
  onClose: () => void;
}

const CertificateInformationModal = ({ onClose }: CertificateInformationModalProps) => {
  return (
    <Modal title={'Informatii Setari Adeverinta'} onClose={onClose}>
      <div className="flex flex-col px-12 w-full gap-4">
        <div className="flex gap-4 flex-col">
          <h3>Variabile</h3>
          <p className="">
            Variabilele sunt inlocuite cu datele cererii + datele clientului + datele companiei.
          </p>
          <p className="italic">Exemplu: {'{name}'} va fi inlocuit cu numele angajatului.</p>
          <ul>
            <span className="underline">Informatiile disponibile sunt:</span>
            <li>1. Nume: {`{name}`}</li>
            <li>2. CNP: {`{cnp}`}</li>
            <li>3. Data inceput: {`{start_date}`}</li>
            <li>4. Date sfarsit: {`{end_date}`}</li>
            <li>5. Nume client: {`{client_name}`}</li>
            <li>6. Nume companie: {`{company_name}`}</li>
            <li>7. Functii detinute: {`{job_titles}`}</li>
            <li>8. Perioade de munca: {`{working_periods}`}</li>
            <li>9. Loc de nastere: {`{birthplace}`}</li>
            <li>10. Alias: {`{alias}`}</li>
            <li>11. Data nastere: {`{birthdate}`} - determinat din CNP</li>
            <li>12. Observatii: {`{details}`}</li>
          </ul>

          <p>
            De asemenea se poate ajusta alinierea textului pentru paragrafe: stanga | centru |
            dreapta. Centrarea stanga va impune o aliniere de tip justify.
          </p>
        </div>
        <hr />
        <div className="flex flex-col gap-4">
          <h3>LOGO</h3>
          <p className="text-md">
            Imaginea pentru logo trebuie incarcata separat pe site-ul:{' '}
            <a className="text-sm" href="https://postimages.org" target="_blank" rel="noreferrer">
              postimages.org
            </a>{' '}
            si utilizat link-ul direct (direct link). Doar formatele: .jpeg / .jpg / .png
          </p>
        </div>
        <hr />
        <p className="text-sm italic">
          Datele preincarcate sunt exemple fictive si nu reprezinta date reale.
        </p>
      </div>
    </Modal>
  );
};

export default CertificateInformationModal;
